import React from "react";
import { Grid } from "Components/Base/Layout/Grid";
import { Box } from "Components/Base/Layout/Box";
import CourseCard from "./CourseCard";
import { useLearningCatalogue } from "../context";

const CourseCards = ({ languageContext }) => {
  const { state } = useLearningCatalogue();
  const {
    learningActivities,
    displayImage,
    listView,
    displayRating,
    isPublic,
  } = state;

  if (!learningActivities) {
    return null;
  }

  // Use the courses field which contains the current page data
  const currentPageCourses = learningActivities.courses || [];

  if (!currentPageCourses.length) {
    return null;
  }

  return (
    <Box sx={{ padding: "32px 0 !important" }}>
      <Grid container spacing={2} className="learning-course-grid">
        {currentPageCourses.map((learningActivity) => (
          <CourseCard
            key={`course-card-${learningActivity.id}`}
            learningActivity={learningActivity}
            languageContext={languageContext}
            displayImage={displayImage}
            listView={listView}
            displayRating={displayRating}
            isPublic={isPublic}
          />
        ))}
      </Grid>
    </Box>
  );
};

export default CourseCards;
